// extracted by mini-css-extract-plugin
export default {"layout":"PersonalInfoLayout_layout__+8M1P","contentLayout":"PersonalInfoLayout_contentLayout__Rjiht","content":"PersonalInfoLayout_content__aAlVe"};